import type { AppProps } from 'next/app';
import Head from 'next/head';

import { RouteHandlerReturn } from 'src/types/model';

import '../styles/global/global.scss';

function App({ Component, pageProps }: AppProps<RouteHandlerReturn>): JSX.Element {
  return (
    <>
      <Head>
        <meta name="robots" content="index,follow" />
      </Head>
      <Component {...pageProps} />
    </>
  );
}

export default App;
